<template>
	<transition name="opacity">
		<aside v-show="isShow" class="bs-dialog-center">
			<div
				class="bs-overlay bs-overlay--full bs-overlay--revamp"
				@click="hide"
			></div>
			<div :class="['bs-dialog-center-container']">
				<button
					class="bs-icon bs-dialog-center__close"
					@click="hide"
					tabindex="0"
				>
					<BaseIcon
						:name="'close_v1'"
						class="h-24px w-24px cursor-pointer fill-n-950"
					/>
				</button>
				<div class="bs-dialog-center__body">
					<slot name="content" />
				</div>
			</div>
		</aside>
	</transition>
</template>

<script lang="ts" setup>
import { useSlots } from 'vue'
import useOverlay from '@/legacy/ts/useOverlay'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'

const props = defineProps({
	modelValue: {
		type: Boolean,
		default: false,
	},
})

const slots = useSlots()
const updateModelValue = (value: boolean) => {
	emit('update:modelValue', value)
}
const { isShow, hide } = useOverlay(props, updateModelValue)

const emit = defineEmits(['update:modelValue'])
</script>
